export default function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_forceReduced.js
// module id = 1310
// module chunks = 1